import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(35.000000, 30.000000)">
        <path
          zoomAndPan="10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          //d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
          d="M29.26 28.14C29.26 30.02 28.82 31.64 27.94 33C27.1 34.32 25.7 35.54 23.74 36.66C22.42 37.46 20.88 38.06 19.12 38.46C17.36 38.86 15.58 39.06 13.78 39.06C11.94 39.06 9.66 38.46 6.94 37.26C4.98 36.3 3.42 35.16 2.26 33.84C1.14 32.52 0.58 31.08 0.58 29.52C0.58 28.44 0.82 27.66 1.3 27.18C1.78 26.66 2.56 26.4 3.64 26.4C4.2 26.4 4.78 26.64 5.38 27.12C5.98 27.56 6.34 28 6.46 28.44C7.02 30.08 8 31.34 9.4 32.22C10.8 33.06 12.54 33.48 14.62 33.48C17.02 33.48 19.02 33.04 20.62 32.16C22.26 31.28 23.08 30.1 23.08 28.62C23.08 27.18 22.2 25.9 20.44 24.78C18.68 23.66 16.88 22.88 15.04 22.44C12.4 21.72 10.06 20.86 8.02 19.86C5.9 18.82 4.32 17.54 3.28 16.02C2.24 14.5 1.72 12.9 1.72 11.22C1.72 9.66 2.26 8.08 3.34 6.48C4.42 4.84 5.7 3.66 7.18 2.94C7.98 2.54 9.34 2.12 11.26 1.68C13.22 1.2 14.64 0.96 15.52 0.96C16.68 0.96 17.96 1.1 19.36 1.38C20.76 1.66 21.9 2.06 22.78 2.58C24.54 3.58 25.84 4.48 26.68 5.28C27.52 6.08 27.94 7.08 27.94 8.28C27.94 9 27.66 9.64 27.1 10.2C26.58 10.76 25.66 11.04 24.34 11.04C24.02 11.04 23.7 10.9 23.38 10.62C23.06 10.34 22.66 9.92 22.18 9.36C21.54 8.52 20.92 7.96 20.32 7.68C19.72 7.48 18.84 7.26 17.68 7.02C16.56 6.78 15.56 6.66 14.68 6.66C13.72 6.66 12.72 6.86 11.68 7.26C10.64 7.66 9.76 8.24 9.04 9C8.36 9.72 8.02 10.56 8.02 11.52C8.02 12.32 8.38 13.02 9.1 13.62C9.86 14.18 10.76 14.64 11.8 15C13 15.48 14.3 15.9 15.7 16.26C17.54 16.82 19.04 17.34 20.2 17.82C21.4 18.26 22.56 18.82 23.68 19.5C25.64 20.66 27.06 21.86 27.94 23.1C28.82 24.3 29.26 25.98 29.26 28.14Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
